const regHex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i

export {
  deepClone,
  hex2rgba,
  redirectToLogin,
  debounce
}

function debounce (fn, idle = 200) {
  let last
  return function () {
    const ctx = this
    const args = arguments
    last && clearTimeout(last)
    last = setTimeout(() => {
      fn.apply(ctx, args)
    }, idle)
  }
}

function deepClone (original, cache) {
  if (original === null || typeof original !== 'object') {
    return original
  }

  if (cache) {
    const hit = cache.find(c => c.original === original)
    if (hit) {
      return hit.copy
    }
  }

  const copy = Array.isArray(original) ? [] : {}
  cache && cache.push({
    original,
    copy
  })

  Object.keys(original).forEach(key => {
    copy[key] = deepClone(original[key], cache)
  })

  return copy
}

function hex2rgba (hex, alpha = 1) {
  let result = regHex.exec(hex)
  if (alpha > 1) {
    alpha = 1
  } else if (alpha < 0) {
    alpha = 0
  }
  return {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16),
    alpha,
    setAlpha (_alpha) {
      this.alpha = _alpha
      return this
    },
    valueOf () {
      return 'rgba(' + this.r + ', ' + this.g + ', ' + this.b + ', ' + this.alpha + ')'
    }
  }
}

function redirectToLogin (context) {
  if (!context.$route.meta.requireAuth) {
    return
  }
  if (!context.token || !context.user) {
    context.$router.push({
      name: 'Login',
      query: {
        redirect: context.$route.fullPath
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/libs/util.js